<template >
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <v-layout column>
          <v-flex v-if="service.pos">
            <DueDate :service="service.pos"></DueDate>
          </v-flex>
          <v-flex>
            <v-layout row wrap>
              <v-flex xs6="xs6">
                <v-card min-height="130px" :color="promotionCountClass" dark>
                  <v-card-text style="height: 128px">
                    <v-layout align-center justify-center column fill-height v-if="!isPromotionLoading">
                      <h1 class="display-1 font-weight-light">
                        {{ promotionCount }}
                      </h1>
                      <div class="text-xs-center body-1">
                        Promotion Delivered
                      </div>
                    </v-layout>
                    <v-layout align-center justify-center row fill-height v-else>
                      <v-progress-circular :size="60" :width="7" color="white"
                        indeterminate="indeterminate"></v-progress-circular>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6="xs6">
                <v-card min-height="130px" :color="promotionAmountClass" dark>
                  <v-card-text style="height: 128px">
                    <v-layout align-center justify-center column fill-height v-if="!isPromotionLoading">
                      <h1 class="display-1 font-weight-light">
                        {{ promotionAmount | currency }}
                      </h1>
                      <div class="text-xs-center body-1">
                        Promotion Amount Paid
                      </div>
                    </v-layout>
                    <v-layout align-center justify-center row fill-height v-else>
                      <v-progress-circular :size="60" :width="7" color="white"
                        indeterminate="indeterminate"></v-progress-circular>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="service.pos">
            <Plan></Plan>
          </v-flex>
          <v-flex>
            <v-card>
              <v-toolbar class="elevation-0" height="45" color="gray">
                <v-toolbar-title>
                  <h1 class="subheading">{{ $t("labels.business") }}</h1>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.HowDidYouFindUs") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right" v-if="location.findUsDetail">{{
                      location.findUsDetail.selector }}</v-flex>
                    <v-flex class="font-weight-regular text-xs-right" v-else>Not Selected</v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.businessType") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right" v-if="location.businessTypeDetail">{{
                      location.businessTypeDetail.selector }}</v-flex>
                    <v-flex class="font-weight-regular text-xs-right" v-else>Not Selected</v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex v-if="!service.pos">
            <SetPin> </SetPin>
          </v-flex>
          <v-flex>
            <v-card>
              <v-toolbar class="elevation-0" height="45" color="gray">
                <v-toolbar-title>
                  <h1 class="subheading">{{ $t("labels.promotionRate") }}</h1>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.sms") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right">{{
                      location.smsRate
                    }}</v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.mms") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right">{{
                      location.mmsRate
                    }}</v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card>
              <v-toolbar class="elevation-0" height="45" color="gray">
                <v-toolbar-title>
                  <h1 class="subheading">
                    {{ $t("labels.organizationInformation") }}
                  </h1>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout column>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.organizationName") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right"><a @click="open">{{ organization.organizationName
                    }}</a>
                      <v-tooltip class="ml-1 pointer" bottom="bottom"><template slot="activator">
                          <v-icon color="info" small="small" dark @click="openWithIcon">open_in_new</v-icon>
                        </template><span>Open in new tab</span></v-tooltip>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.ownerName") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right">{{
                      organization.ownerName
                    }}</v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.primaryEmail") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right"><a @click="sendEmail(organization.primaryEmail)">{{
                      organization.primaryEmail
                    }}</a></v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.locationCount") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right"><a @click="$emit('active', 5)">{{
                      organization.Stores.length
                    }}</a></v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card>
              <v-toolbar class="elevation-0" height="45" color="gray">
                <v-toolbar-title>
                  <h1 class="subheading">
                    {{ $t("labels.loginInformation") }}
                  </h1>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout column>
                  <v-layout row wrap></v-layout>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.loginEmail") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex class="font-weight-regular text-xs-right"><a @click="sendEmail(organization.loginEmail)">{{
                      organization.loginEmail
                    }}</a></v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.loginPassword") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex v-if="checkRightStatus(31)" class="font-weight-regular text-xs-right"><a
                        @click="sendPassword()">Send Password</a></v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout row wrap>
                    <v-flex>{{ $t("labels.temporaryPassword") }}</v-flex>
                    <v-spacer></v-spacer>
                    <v-flex v-if="checkRightStatus(67)" class="font-weight-regular text-xs-right"><a
                        @click="generateTempPassword()">Generate Password</a></v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md8="md8">
        <v-layout row wrap>
          <v-flex xs12 sm6 md5="md5">
            <v-layout row wrap>
              <v-flex xs12>
                <LocationStatus> </LocationStatus>
              </v-flex>
              <v-flex xs12 v-if="service.pos">
                <Status serviceID="192" service="POS"></Status>
              </v-flex>
              <v-flex xs12 v-if="service.pos && checkRightStatus(56)">
                <SetPin></SetPin>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md7="md7">
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout column>
                  <v-flex>
                    <v-card>
                      <v-toolbar class="elevation-0" height="45" color="gray">
                        <v-toolbar-title>
                          <h1 class="subheading">
                            {{ $t("labels.locationNote") }}
                          </h1>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <toggle-button v-if="checkRightStatus(48)" @change="updateAlert" :labels="true" color="red"
                          v-model="location.alertOn" :value="location.alertOn" :sync="true">
                        </toggle-button>
                        <v-btn small="small" v-if="checkRightStatus(35)" color="info" dark @click="updateNote()"
                          icon="icon">
                          <v-icon small="small">save</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <v-textarea :rows="rowCount" v-model="location.Notes">
                        </v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex>
                    <v-card>
                      <v-toolbar class="elevation-0" height="45" color="gray">
                        <v-toolbar-title>
                          <h1 class="subheading">Software Alert</h1>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <toggle-button :labels="true" color="red" v-model="location.softwareAlert"
                          :value="location.softwareAlert" :sync="true">
                        </toggle-button>
                        <v-btn small="small" v-if="checkRightStatus(35)" color="info" dark @click="updateSoftwareAlert()"
                          icon="icon">
                          <v-icon small="small">save</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text>
                        <v-textarea :rows="3" v-model="location.softwareAlertNotes">
                        </v-textarea>
                        <v-select :items="alertList" v-model="location.alertColor"></v-select>
                        <v-text-field v-model="location.alertUrl" label="Alert URL"></v-text-field>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <CommentList :refID="location.storeID" :typeId="1"></CommentList>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CommentList from "../../Comment/components/List";
import locationService from "../service.js";
import Status from "./Status";
import DueDate from "./components/DueDate";
import SetPin from "./components/SetPin";
import Plan from "./components/Plan";
import LocationStatus from "./LocationStatus";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      alertList: ['warning', 'lock', 'info'],
      rowCount: 6,
      promotionCount: 0,
      promotionAmount: 0,
      isPromotionLoading: true,
    };
  },
  watch: {
    location() {
      this.setPageTitle(
        this.location.CSPID + " - " + this.location.businessName + "- Store"
      );
      this.SetPOSSystem();
    },
  },
  mounted() {
    this.getPromotionDeliveredByStoreID();
    this.setPageTitle(
      this.location.CSPID + " - " + this.location.businessName + "- Store"
    );
    this.SetPOSSystem();
  },
  methods: {
    ...mapActions("location", ["setLocation", "setOrgPinNumber"]),
    ...mapActions("global", ["setPageTitle", "sendEmail", "initOrganization"]),

    SetPOSSystem() {
      if (this.service.pos) {
        this.rowCount = 12;
      }
    },
    generateTempPassword() {
      this.$swal({
        title: "Reason",
        text: "Why are you generating password",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Generate",
        showLoaderOnConfirm: true,
        preConfirm: (reason) => {
          if (!reason) {
            const e = new Error("ReasonError");
            e.name = "reasonNotProvided";
            throw e;
          }
          let data = {
            reason: reason,
            storeID: this.location.storeID,
          };
          return locationService
            .generateTempPassword(this.organization.organizationID, data)
            .then((result) => {
              return result;
            });
        },
        allowOutsideClick: () => !swal.isLoading(),
      })
        .then((result) => {
          console.log("password geenral", result);
          if (result && result.value.status) {
            this.$swal({
              title: "Password Generated!",
              html:
                "Your temporary password is <b>" +
                result.value.data +
                "</b> this password will expire in 30 minutes. ",
              type: "success",
            });
          }
        })
        .catch((error) => {
          this.$swal.fire({
            showConfirmButton: false,
            showCancelButton: false,
            timer: 3000,
            toast: true,
            position: "top-end",
            type: "error",
            title: this.$t(error.name),
          });
          // this.generateTempPassword()
        });
    },
    sendPassword() {
      let data = {
        emailAddress: this.organization.loginEmail,
        subject: "Password for test email",
        password: this.organization.loginPassword,
        ownerName: this.organization.ownerName,
        loginEmail: this.organization.loginEmail,
      };
      locationService.sendPassword(data).then((result) => {
        if (result.status) {
          this.$swal(
            "Password!",
            `Password was send to ${this.organization.loginEmail}.`,
            'success'
          );
        }
      });
    },
    open() {
      this.$router.push({
        path: `/organization/profile/${this.location.organizationID}`,
      });
    },
    openWithIcon() {
      // this.$router.push({ path: `/organization/profile/${this.location.organizationID}` })
      let routeData = this.$router.resolve({
        path: `/organization/profile/${this.location.organizationID}`,
      });
      window.open(routeData.href, "_blank");
    },
    updateNote() {
      this.updateStore({ Notes: this.location.Notes });
    },
    updateSoftwareAlert() {
      const data = {
        softwareAlert: this.location.softwareAlert,
        softwareAlertNotes: this.location.softwareAlertNotes,
        alertUrl: this.location.alertUrl,
        alertColor: this.location.alertColor,
      };

      console.log('test', data)

      this.updateStore(data);
    },
    updateAlert(val) {
      let data = {
        alertOn: val.value,
      };
      this.updateStore(data);
    },
    updateStore(data) {
      console.log("note", data);
      return locationService
        .updateStore(this.location.storeID, data)
        .then((result) => {
          console.log("result", result);
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "success",
              title: "Update Successfully",
            });
          this.setLocation(this.location.storeID);
        });
    },
    getPromotionDeliveredByStoreID() {
      return locationService
        .getPromotionDeliveredByStoreID(this.location.storeID)
        .then((response) => {
          this.isPromotionLoading = false;
          if (response.data.deliverCount) {
            this.promotionCount = response.data.deliverCount;
          }
          if (response.data.amountPaid) {
            this.promotionAmount = response.data.amountPaid;
          }
        });
    },
  },
  components: {
    CommentList,
    Plan,
    LocationStatus,
    DueDate,
    Status,
    SetPin,
  },
  computed: {
    ...mapGetters("location", ["location", "organization", "service"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    promotionCountClass(val) {
      let color = "green lighten-2";
      if (this.promotionCount === 0) {
        color = "red darken-4";
      }
      return color;
    },
    promotionAmountClass(val) {
      let color = "green lighten-2";
      if (this.promotionAmount === 0) {
        color = "red darken-4";
      }
      return color;
    },
  },
};
</script>

<style scoped></style>
